
export const proxy = "http://128.199.0.136:8080";
export const imageProxy = "http://128.199.0.136:8080/uploads";
// export const proxy = "http://localhost:8080";
// export const imageProxy = "http://localhost:8080/uploads";
// export const webProxy = "164.92.65.62/home";
  
// export const  proxy = "http://68.183.110.77:8080";
 